import React, { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  TableCell,
  Button,
  Table,
  TableHead,
  TableRow,
  TableBody,
  CircularProgress,
  Container,
} from '@material-ui/core';

import AssignmentIcon from '@material-ui/icons/Assignment';

import { LICENSE_CHAGES_TYPE, SERVICES_PROPERTIES } from 'app/config/services';
import { useDispatch, useSelector } from 'react-redux';
import { GenericDrawer } from 'app/components/GenericDrawer/GenericDrawer';
import { clearFiles } from 'app/store/slices/forms';
import helpers from 'app/utils/helpers';

import AditionalData from 'app/components/ServicesForms/Licenses/commonComponents/AdditionalData';
import VehicleForm from 'app/components/VehicleForm';

const InfoLicenses = props => {
  const dispatch = useDispatch();
  const { classes, selectedChangeType, oldRequest, oldService, oldLicense, oldCompanyData } = props;

  const cities = useSelector(state => state.forms.cities);
  const vehicleType = useSelector(state => state.vehicle.vehicleType);
  const vehicleCategories = useSelector(state => state.vehicle.vehicleCategories);

  const [vehiclesOld, setVehiclesOld] = useState([]);
  const [itineraryOld, setItineraryOld] = useState([]);
  const [passengersOld, setPassengersOld] = useState([]);
  const [scheduleOld, setScheduleOld] = useState([]);
  const [companiesOld, setCompaniesOld] = useState([]);

  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [vehicleSelected, setVehicleSelected] = useState({});
  const [hasVehicle, setHasVehicle] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);

  const [hasItinerary, setHasItinerary] = useState(false);
  const [hasPassengers, setHasPassengers] = useState(false);
  const [hasSchedule, setHasSchedule] = useState(false);
  const [hasCompanies, setHasCompanies] = useState(false);
  const [hasAditionalData, setHasAditionalData] = useState(false);

  useEffect(() => {
    const init = () => {
      const changeType = Number(selectedChangeType);
      const cdServico = oldService?.cdServico ? oldService.cdServico : oldRequest.cdServico;
      const isItineraryChange = changeType === LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO;
      const isContractChange = changeType === LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO;
      const isCompanyNameChange = changeType === LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL;
      let configurator = {};
      if (cdServico && SERVICES_PROPERTIES[cdServico].configurator) {
        configurator = SERVICES_PROPERTIES[cdServico].configurator;
      }
      if (configurator.hasVehicle) setHasVehicle(true);
      if (isCompanyNameChange) setHasCompany(true);
      if (isItineraryChange && configurator.hasItinerary) setHasItinerary(true);
      if (isContractChange && configurator.hasPassengers) setHasPassengers(true);
      if (isContractChange && configurator.hasSchedules) setHasSchedule(true);
      if (isContractChange && configurator.hasCompanies) setHasCompanies(true);
      if (isContractChange && configurator.hasAditionalData) setHasAditionalData(true);
    };
    init();
  }, [oldRequest, oldService, selectedChangeType]);

  const editElement = (element, index) => {
    setVehicleSelected({
      index,
      content: element?.veiculo,
    });
    setOpenDrawer(true);
  };

  const onSaveRow = async (values, index) => {
    // eslint-disable-next-line no-unused-vars
    const valuesInt = { ...values };
    onCancel();
  };

  const onCancel = () => {
    dispatch(clearFiles());
    setOpenDrawer();
    setVehicleSelected({});
  };

  const weeklyDays = (schedule, index) => {
    return [
      schedule.boSegunda && 'Seg',
      schedule.boTerca && 'Ter',
      schedule.boQuarta && 'Qua',
      schedule.boQuinta && 'Qui',
      schedule.boSexta && 'Sex',
      schedule.boSabado && 'Sab',
      schedule.boDomingo && 'Dom',
    ]
      .filter(day => day)
      .join(', ');
  };

  useEffect(() => {
    const init = () => {
      setLoading(true);
      if (oldLicense?.licencaVeiculos) {
        setVehiclesOld(oldLicense.licencaVeiculos);
      }
      if (oldLicense?.itinerario) {
        setItineraryOld(oldLicense.itinerario);
      }
      if (oldLicense?.passageiros) {
        setPassengersOld(oldLicense.passageiros);
      }
      if (oldLicense?.horarios) {
        setScheduleOld(oldLicense.horarios);
      }
      if (oldLicense?.empresas) {
        setCompaniesOld(oldLicense.empresas);
      }
      setLoading(false);
    };
    init();
  }, [oldLicense]);

  if (loading) {
    return (
      <Grid item xs={12} className={classes.centerProgress}>
        <CircularProgress size={18} />
      </Grid>
    );
  }

  return (
    <>
      <GenericDrawer open={openDrawer} title="Cadastro de Veículo" onClose={() => onCancel()}>
        <Container>
          <VehicleForm
            {...props}
            readOnly={true}
            classes={classes}
            vehicle={vehicleSelected}
            onSave={onSaveRow}
            onCancel={onCancel}
          />
        </Container>
      </GenericDrawer>

      <Grid item xs={12}>
        <h3 className={classes.yellowTitle}>Informações atuais na licença</h3>
      </Grid>

      {hasCompany && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="Nome / Razão Social"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={oldCompanyData.nmCompleto || oldCompanyData.deRazaoSocial}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="CNPJ / CPF"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={helpers.formatarDocumento(
                oldCompanyData.deCpf ||
                  oldCompanyData.deCpfCnpj ||
                  oldCompanyData.deCnpjMatriz ||
                  ''
              )}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}

      {hasVehicle && (
        <>
          <Grid item xs={12}>
            <h3 className={classes.title}>Veículos</h3>
          </Grid>
          <Grid item xs={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.headTableCell} align="center">
                    ID
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left">
                    Placa
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left">
                    Nome do proprietário
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left">
                    CPF / CNPJ
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left">
                    Tipo de veículo
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left">
                    Capacidade
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left">
                    Categoria
                  </TableCell>
                  <TableCell className={classes.headTableCell} align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {vehiclesOld.map((row, indexRow) => {
                  const type = vehicleType.filter(
                    o => o.cdTipoVeiculo === row.veiculo?.cdTipoVeiculo
                  );
                  const category = vehicleCategories.filter(
                    o => o.cdCategoriaVeiculo === row.veiculo?.cdCategoriaVeiculo
                  );
                  return (
                    <TableRow key={`vehi-${indexRow}`} className={classes.tableRow}>
                      <TableCell align="center" component="th" scope="row">
                        {row.veiculo?.cdVeiculo}
                      </TableCell>
                      <TableCell align="left">{row.veiculo?.dePlaca}</TableCell>
                      <TableCell align="left">{row.veiculo?.nmProprietario}</TableCell>
                      <TableCell align="left">{row.veiculo?.deCpfCnpjProprietario}</TableCell>
                      <TableCell align="left">{type[0]?.deTipoVeiculo || ''}</TableCell>
                      <TableCell align="left">{row.veiculo?.qtCapacidade}</TableCell>
                      <TableCell align="left">{category[0]?.deCategoriaVeiculo || ''}</TableCell>
                      <TableCell align="right">
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.btnSigleAction}
                          size="small"
                          onClick={e => editElement(row, indexRow)}
                        >
                          <AssignmentIcon fontSize="inherit" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </>
      )}

      {hasItinerary && (
        <>
          <Grid item xs={12}>
            <h3 className={classes.title}>Itinerário</h3>
          </Grid>
          <Grid item xs={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.headTableCell}>ID</TableCell>
                  <TableCell className={classes.headTableCell}>Município</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {itineraryOld.map((row, indexRow) => {
                  const city = cities.filter(o => o.cdMunicipio === row.cdMunicipio);
                  return (
                    <TableRow key={`vehi-${indexRow}`} className={classes.tableRow}>
                      <TableCell component="th" scope="row">
                        {row.cdLicencaItinerario}
                      </TableCell>
                      <TableCell>{city[0]?.nmMunicipio || ''}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </>
      )}

      {hasPassengers && (
        <>
          <Grid item xs={12}>
            <h3 className={classes.title}>Lista de passageiros</h3>
          </Grid>
          <Grid item xs={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.headTableCell}>Nome completo</TableCell>
                  <TableCell className={classes.headTableCell}>RG</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {passengersOld.map((row, indexRow) => {
                  return (
                    <TableRow key={`pass-${indexRow}`} className={classes.tableRow}>
                      <TableCell component="th" scope="row">
                        {row.deNome}
                      </TableCell>
                      <TableCell>{row.deRg}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </>
      )}

      {hasSchedule && (
        <>
          <Grid item xs={12}>
            <h3 className={classes.title}>Lista de horários</h3>
          </Grid>
          <Grid item xs={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.headTableCell}>Hora inicial</TableCell>
                  <TableCell className={classes.headTableCell}>Hora final</TableCell>
                  <TableCell className={classes.headTableCell}>Dias da semana</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {scheduleOld.map((row, indexRow) => {
                  return (
                    <TableRow key={`pass-${indexRow}`} className={classes.tableRow}>
                      <TableCell align="left">{row.hrInicial}</TableCell>
                      <TableCell align="left">{row.hrFinal}</TableCell>
                      <TableCell align="left">{weeklyDays(row, indexRow)}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </>
      )}

      {hasCompanies && (
        <>
          <Grid item xs={12}>
            <h3 className={classes.title}>Lista de empresa(s) contratante(s) / orgão(s)</h3>
          </Grid>
          <Grid item xs={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.headTableCell}>Nome / Razão Social</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {companiesOld.map((row, indexRow) => {
                  return (
                    <TableRow key={`pass-${indexRow}`} className={classes.tableRow}>
                      <TableCell component="th" scope="row">
                        {row.deRazaoSocial}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </>
      )}

      {hasAditionalData && (
        <Grid item xs={12}>
          <AditionalData {...props} oldInfo={true} classes={classes} />
        </Grid>
      )}
    </>
  );
};

export default InfoLicenses;
